import React from "react";
import Onboarding from "../../Pages/Onboarding/Onboarding";
import { Navigate, Route } from "react-router-dom";
import { EndPoints } from "../../../utils/apiEndpoints";

export const OnboardingRoutes = () => (
    <React.Fragment>
        <Route path={EndPoints.ONBOARDING} element={<Onboarding />} />
        <Route path="*" element={<Navigate to={EndPoints.ONBOARDING} replace />} />
    </React.Fragment>
);